import a from  '../img/Photography/GOOGLE-1.png';
import b from  '../img/Photography/dsa.png';
import c from  '../img/Photography/java.png';
import d from  '../img/Photography/js.png';
import e from  '../img/Photography/openCv.png';
import f from  '../img/Photography/python.png';
import g from  '../img/Photography/acc.png';
import h from  '../img/Photography/align.png';
import i from  '../img/Photography/aws ec2.png';
import j from  '../img/Photography/aws.png';
import k from  '../img/Photography/tcs comm.png';
import l from  '../img/Photography/ISEA.png';
import m from  '../img/Photography/tcs int.png';
import n from  '../img/Photography/campus a.png';

const Photography = [
    {
        id: 1,
        title: 'Google Cloud Developer',
        date: '23',
        month: 'January, 2022',
        image: a,
        link: 'https://drive.google.com/file/d/1v9R6twCSUOLUmijH0SVtHJ7usaYawZ_D/view?usp=sharing'
    },
    {
        id: 2,
        title: 'Master Data Structures & Algorithms in C++',
        date: '28',
        month: 'May, 2022',
        image: b,
        link: 'https://drive.google.com/file/d/1GgkZ6M5SC20K020nYq4rqpjYReW_Y4dl/view?usp=sharing'
    },
    {
        id: 3,
        title: 'Java Programming',
        date: '13',
        month: 'April, 2021',
        image: c,
        link: "https://drive.google.com/file/d/1TZw2t1lA_A0mdb3vN_EYauNIYvUsP0_9/view?usp=sharing"
    },
    {
        id: 4,
        title: 'JavaScript from LetUpgrade',
        date: '19',
        month: 'November, 2021',
        image: d,
        link: 'https://drive.google.com/file/d/1qW7frdt3fHUQIHYPvA4XBjJObLAe_RyM/view?usp=sharing'
    },
    {
        id: 5,
        title: 'Face Detection with OpenCV in Python',
        date: '01',
        month: 'December, 2021',
        image: e,
        link: 'https://drive.google.com/file/d/1anX7yZIvZ1ZliJaoayGx8xGNOOJeawYS/view?usp=sharing'
    },
    {
        id: 6,
        title: 'Python from HackerRank/CodewithHarry',
        date: '01',
        month: 'April',
        image: f,
        linl: 'https://drive.google.com/file/d/129U31neMUCM8Z9bFZ2kBt0xOrZfPChqU/view?usp=sharing'
    },
    {
        id: 7,
        title: 'Software Developing Program from Accenture',
        date: '06',
        month: 'September, 2022',
        image: g,
        link: 'https://drive.google.com/file/d/1yO9P7i94F8QzlwodZgRSyGCRZojEuTVS/view?usp=sharing'
    },
    {
        id: 8,
        title: 'align Software Engineering Program',
        date: '07',
        month: 'September, 2022',
        image: h,
        link: 'https://drive.google.com/file/d/1BePAsOxKuQIRCSBTJ9rP1EjtSwVDWp5M/view?usp=sharing'
    },
    {
        id: 9,
        title: 'Amazon EC2 - Secure Cloud Services',
        date: '20',
        month: 'August, 2020',
        image: i,
        link: 'https://drive.google.com/file/d/1GV5DQ6zp-GXmtID1aD0nku0mZxcYZ2gA/view?usp=sharing'
    },
    {
        id: 10,
        title: 'Amazon Web Services CodeBuild',
        date: '01',
        month: 'August, 2020',
        image: j,
        link: 'https://drive.google.com/file/d/1zBNYABG1NQpudyk7g6MGa41vhx6k6-Q1/view?usp=sharing'
    },
    {
        id: 11,
        title: 'TCS Communication Skills',
        date: '29',
        month: 'September, 2022',
        image: k,
        link: 'https://drive.google.com/file/d/1p3xeZHKsQ0yVdYVBva0CW8aEbW6ZpxxF/view?usp=sharing'
    },
    {
        id: 12,
        title: 'ISEA Digital',
        date: '1',
        month: 'September, 2022',
        image: l,
        link: 'https://drive.google.com/file/d/1HxA_O1DykjpQiopujbdS8tVSx2Ray_z5/view?usp=sharing'
    },
    {
        id: 13,
        title: 'TCS Interview Skills',
        date: '20',
        month: 'September, 2022',
        image: m,
        link: 'https://drive.google.com/file/d/19uxGNd_8nIFX2jojsEh3uqu-JdUZGZec/view?usp=sharing'
    },
    {
        id: 14,
        title: 'Campus Ambassador',
        date: '24',
        month: 'October, 2021',
        image: n,
        link: 'https://drive.google.com/file/d/1sTu9YTCOkPziALv-97lVE8Yzt7_rGBvI/view?usp=sharing'
    }
]

export default Photography;